"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MercoaClient = void 0;
const Client_1 = require("./api/resources/entityGroup/client/Client");
const Client_2 = require("./api/resources/entity/client/Client");
const Client_3 = require("./api/resources/invoiceTemplate/client/Client");
const Client_4 = require("./api/resources/invoice/client/Client");
const Client_5 = require("./api/resources/organization/client/Client");
const Client_6 = require("./api/resources/bankLookup/client/Client");
const Client_7 = require("./api/resources/calculate/client/Client");
const Client_8 = require("./api/resources/customPaymentMethodSchema/client/Client");
const Client_9 = require("./api/resources/ocr/client/Client");
const Client_10 = require("./api/resources/paymentMethods/client/Client");
const Client_11 = require("./api/resources/transaction/client/Client");
class MercoaClient {
    constructor(_options) {
        this._options = _options;
    }
    get entityGroup() {
        var _a;
        return ((_a = this._entityGroup) !== null && _a !== void 0 ? _a : (this._entityGroup = new Client_1.EntityGroup(this._options)));
    }
    get entity() {
        var _a;
        return ((_a = this._entity) !== null && _a !== void 0 ? _a : (this._entity = new Client_2.Entity(this._options)));
    }
    get invoiceTemplate() {
        var _a;
        return ((_a = this._invoiceTemplate) !== null && _a !== void 0 ? _a : (this._invoiceTemplate = new Client_3.InvoiceTemplate(this._options)));
    }
    get invoice() {
        var _a;
        return ((_a = this._invoice) !== null && _a !== void 0 ? _a : (this._invoice = new Client_4.Invoice(this._options)));
    }
    get organization() {
        var _a;
        return ((_a = this._organization) !== null && _a !== void 0 ? _a : (this._organization = new Client_5.Organization(this._options)));
    }
    get bankLookup() {
        var _a;
        return ((_a = this._bankLookup) !== null && _a !== void 0 ? _a : (this._bankLookup = new Client_6.BankLookup(this._options)));
    }
    get calculate() {
        var _a;
        return ((_a = this._calculate) !== null && _a !== void 0 ? _a : (this._calculate = new Client_7.Calculate(this._options)));
    }
    get customPaymentMethodSchema() {
        var _a;
        return ((_a = this._customPaymentMethodSchema) !== null && _a !== void 0 ? _a : (this._customPaymentMethodSchema = new Client_8.CustomPaymentMethodSchema(this._options)));
    }
    get ocr() {
        var _a;
        return ((_a = this._ocr) !== null && _a !== void 0 ? _a : (this._ocr = new Client_9.Ocr(this._options)));
    }
    get paymentMethods() {
        var _a;
        return ((_a = this._paymentMethods) !== null && _a !== void 0 ? _a : (this._paymentMethods = new Client_10.PaymentMethods(this._options)));
    }
    get transaction() {
        var _a;
        return ((_a = this._transaction) !== null && _a !== void 0 ? _a : (this._transaction = new Client_11.Transaction(this._options)));
    }
}
exports.MercoaClient = MercoaClient;
